export default {
  type: 'user_affiliation',
  name: 'User Affiliation',
  description: 'Users grouped by their affiliation',
  search: {
    search: 'allPeople',
    orderBy: {
      type: 'PeopleOrderBy',
      default: 'AFFILIATION_ASC'
    },
    fields: [
      { name: 'personId', searchable: false },
      { name: 'fullName', label: 'Name', searchable: false },
      { name: 'username', searchable: false },
      { name: 'email', searchable: false },
      {
        name: 'affiliation',
        type: 'select',
        options: {
          lookup: 'allInstitutions',
          value: 'instName',
          text: 'instName',
          allowNull: true,
          nullText: 'All',
          params: [
            {
              field: 'orderBy',
              passArray: true,
              type: 'InstitutionsOrderBy',
              default: 'INST_NAME_ASC'
            }
          ]
        }
      },
      { name: 'accessStatement', searchable: false },
      { name: 'scienceUser', type: 'boolean', searchable: false }
    ]
  }
}
